import { Component } from '@angular/core';
import { RouterLink } from '@angular/router';
import { RadioGroupComponent } from '@sircon/sircon-ui-framework';
import { FormsModule } from '@angular/forms';

@Component({
    selector: 'app-login-help',
    templateUrl: './login-help.component.html',
    styleUrls: ['./login-help.component.less'],
    imports: [RouterLink, RadioGroupComponent, FormsModule]
})
export class LoginHelpComponent {

    helpOptions = [
        { stateName: '/forgotPassword', description: 'Forgot password' },
        { stateName: '/account-recovery-workflow', description: 'Lost access to my email' }
    ];
    selection;
}
